import uniqBy from 'lodash/uniqBy'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import type { Cycle } from 'modules/surveys/store/models/AnalyticResult'
import AnalyticResult from 'modules/surveys/store/models/AnalyticResult'

export class AnalyticResults extends Collection<AnalyticResult> {
  constructor(attrs = []) {
    super(attrs)
    makeObservable(this, {
      numeric: computed,
      cycles: computed,
    })
  }

  model() {
    return AnalyticResult
  }

  // Filtering out the results that have no numeric question
  get numeric(): AnalyticResult[] {
    return this.filter((model) => {
      return model.numericQuestions.size > 0
    })
  }

  get cycles(): Cycle[] {
    // Unluckily, Set or other data structures cannot compare arrays. To do it fast, we iterate over
    // it comparing their strignified version
    const result = uniqBy(
      this.models.flatMap((model) => Array.from(model.cycles)),
      (cycle: Cycle) => JSON.stringify(cycle)
    )
    result.sort(([a], [b]) => (new Date(a) < new Date(b) ? -1 : 1))
    return result
  }
}
